import { IconActionChevronDownSmall16 } from '@cian/ui-kit-design-tokens/icons';
import * as React from 'react';
import * as styles from './styles.css';

export interface ILinkButtonProps {
  value: React.ReactNode;
  onClick(): void;
}

export function SelectField({ value, onClick }: ILinkButtonProps) {
  return (
    <div className={styles['container']} onClick={onClick}>
      <span className={styles['value']}>{value}</span>
      <span className={styles['icon']}>
        <IconActionChevronDownSmall16 color="icon-main-default" />
      </span>
    </div>
  );
}
